import clsx from 'clsx'
import { useState } from 'react'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'

import PanelKinerja from './PanelKinerja'

import type { HTMLAttributes } from 'react'
import type {
  KinerjaPraktikPembelajaranContentIndikator,
  KinerjaUtamaDetail,
} from 'types/kinerja'

interface AdjustmentInfoProps extends HTMLAttributes<HTMLDivElement> {
  text?: string
  label?: string
  showCheckButton?: boolean
  showDetails?: boolean
  originalKinerjaNumber?: string | number
  kinerjaNumber?: string | number
  kinerja?: KinerjaPraktikPembelajaranContentIndikator | KinerjaUtamaDetail
  originalKinerja?:
    | KinerjaPraktikPembelajaranContentIndikator
    | KinerjaUtamaDetail

  originalLabel?: string
  reviewLabel?: string
}

export default function AdjustmentInfo({
  text = 'Ada penyesuaian',
  label = 'Rencana Hasil Kerja',
  showCheckButton = true,
  showDetails = true,
  originalKinerjaNumber = '1',
  kinerjaNumber = '1',
  kinerja,
  originalKinerja,
  className,
  originalLabel = 'Perencanaan Guru',
  reviewLabel = 'Penyesuaian dari Kepala Sekolah',
  ...otherProps
}: AdjustmentInfoProps) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <div
        {...otherProps}
        className={clsx(
          'inline-flex px-4 py-3 justify-center items-center rounded bg-[#ECFEF2] border border-green-50 gap-1 tracking-[0.5px] w-[416px]',
          className
        )}
      >
        <Icon className="!text-green-50 !text-[20px] !w-5 !h-5">check</Icon>

        <Text variant="subheading" className="uppercase flex-1">
          {text}
        </Text>

        {showCheckButton && (
          <Button
            size="sm"
            color="white"
            className="!bg-transparent"
            onClick={() => setIsOpen(true)}
          >
            Cek
          </Button>
        )}
      </div>

      <Dialog size="lg" isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <DialogOverlay />
        <DialogContent>
          <div className="w-full px-12 py-9 flex flex-col gap-4">
            {!!originalKinerja?.id && (
              <>
                <div className="flex flex-col gap-2">
                  <Text color="primary" variant="heading-md">
                    {originalLabel}
                  </Text>
                  <PanelKinerja
                    label={label}
                    kinerja={originalKinerja}
                    number={originalKinerjaNumber}
                    className="w-full"
                    linkGuide=""
                    showDetails={showDetails}
                  />
                </div>

                <div className="flex justify-center">
                  <Icon>arrow_downward</Icon>
                </div>
              </>
            )}

            <div className="flex flex-col gap-2">
              <Text color="primary" variant="heading-md">
                {reviewLabel}
              </Text>
              <PanelKinerja
                label={label}
                kinerja={kinerja}
                number={kinerjaNumber}
                className="w-full"
                showDetails={showDetails}
                linkGuide=""
              />
            </div>

            <div className="flex justify-center">
              <Button className="!w-auto" onClick={() => setIsOpen(false)}>
                Saya mengerti
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
